import { useState, useEffect } from "react";
import { isSupported } from "firebase/messaging";
import { AppDispatch, RootState } from "../../../../core/store/store";
import { useDispatch, useSelector } from "react-redux";
import { changePushState } from "../../../profile/presentation/store/OnboardingSlice";

export const useDeviceConditions = (ignoredActiveNotification: boolean = false) => {
	const [isIphone, setIsIphone] = useState<boolean>(false);
	const statusNotification = localStorage.getItem("NOTIFICATION_PERMISSION_STATE");
	const [isNotificationSupported, setNotificationSupported] = useState<boolean>(false);
	const dispatch: AppDispatch = useDispatch();
	const { pushState } = useSelector((state: RootState) => state.onboarding);

	useEffect(() => {
		const userAgent = navigator.userAgent;
		const isIphoneDevice = /iPhone|iPad|iPod/i.test(userAgent);
		setIsIphone(isIphoneDevice);

		isSupported().then((suported) => {
			setNotificationSupported(suported);
		});
		
		dispatch(changePushState(statusNotification??''));

		const handleNotificationPermission = () => {
			if (typeof Notification !== "undefined") {
				if (Notification.permission === "granted") {
					localStorage.setItem("NOTIFICATION_PERMISSION_STATE", "enabled");
					dispatch(changePushState("enabled"));
				} else if (Notification.permission === "denied") {
					localStorage.setItem("NOTIFICATION_PERMISSION_STATE", "disabled");
					dispatch(changePushState('disabled'));
				} else {
					localStorage.removeItem("NOTIFICATION_PERMISSION_STATE");
					dispatch(changePushState(null));
				}
			}
		};

		handleNotificationPermission();

	}, [dispatch, statusNotification]);

	const shouldShowModal =
		(isNotificationSupported || isIphone) &&
		(
			ignoredActiveNotification ||
			!pushState ||
			pushState === "disabled" ||
			(typeof Notification !== "undefined" && Notification.permission === "default")
		);

	return { shouldShowModal, statusNotification };
};
